import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function ProgramsPage() {
  const programs = [
    {
      id: 'cfn',
      title: 'Christ Family Network (CFN)',
      description: 'Small group teaching and prayer centers planted across cities, towns, and nations',
      icon: 'ri-group-line',
      link: '/cfn',
      features: ['Weekly fellowship meetings', 'Apostolic teaching', 'Prayer and worship', 'Discipleship training']
    },
    {
      id: 'ofn',
      title: 'One Fold Network',
      description: 'A global discipleship network raising sons and daughters through intentional spiritual formation',
      icon: 'ri-user-follow-line',
      link: '/one-fold',
      features: ['Leadership development', 'Spiritual formation', 'Mentorship programs', 'Ministry training']
    },
    {
      id: 'ebi',
      title: 'Ecclesia of Believers International (EBI)',
      description: 'Apostolic churches and assemblies under one doctrine and spiritual oversight',
      icon: 'ri-church-line',
      link: '/ecclesia',
      features: ['Church planting', 'Apostolic oversight', 'Doctrinal unity', 'Spiritual covering']
    },
    {
      id: 'abic',
      title: 'All Believers International Convention (ABIC)',
      description: 'Annual global apostolic summit gathering saints from every nation',
      icon: 'ri-global-line',
      link: '/convention',
      features: ['Annual gatherings', 'International fellowship', 'Apostolic teachings', 'Global networking']
    },
    {
      id: 'rrm',
      title: 'Root and Reign Mission',
      description: 'Rural and unreached people mission arm, raising firebrands in dry lands',
      icon: 'ri-seedling-line',
      link: '/missions',
      features: ['Rural evangelism', 'Church planting', 'Missionary training', 'Unreached peoples']
    },
    {
      id: 'mmm',
      title: 'Meal and Medical Mission',
      description: 'Ministry of healing, compassion, and economic empowerment for the poor and vulnerable',
      icon: 'ri-heart-pulse-line',
      link: '/medical-mission',
      features: ['Medical outreach', 'Food distribution', 'Economic empowerment', 'Community care']
    },
    {
      id: 'grn',
      title: 'Gallery of Revelation Network',
      description: 'Library, Publishing, Christian education, doctrine manuals, and training for Bible colleges',
      icon: 'ri-book-open-line',
      link: '/publications',
      features: ['Publishing ministry', 'Educational resources', 'Doctrine manuals', 'Bible college training']
    },
    {
      id: 'cgc',
      title: 'Christ Gospel Crusade (CGC)',
      description: 'Annual, simultaneous global evangelistic campaigns under one message and one banner',
      icon: 'ri-megaphone-line',
      link: '/crusades',
      features: ['Global evangelism', 'Mass crusades', 'Unified campaigns', 'Soul winning']
    },
    {
      id: 'jcr',
      title: 'Jesus Christ Rally (JCR)',
      description: 'Community street evangelism and altar of worship movement across territories',
      icon: 'ri-community-line',
      link: '/rallies',
      features: ['Street evangelism', 'Community outreach', 'Public worship', 'Territorial impact']
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-[#b8144a] to-[#d91e5b] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">PAAM Programs</h1>
          <p className="text-xl max-w-4xl mx-auto">
            Nine Strategic Arms of the Global Apostolic Engine - Each designed to fulfill a dimension of the mandate
          </p>
        </div>
      </section>

      {/* Programs Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Nine Strategic Programs</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              PAAM is structured around nine core arms, each designed to fulfill a dimension of the mandate 
              under the leadership of the International Apostolic Council (IAC)
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {programs.map((program) => (
              <div key={program.id} className="bg-gray-50 rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="p-6">
                  <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${program.icon} text-white text-xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">{program.title}</h3>
                  <p className="text-gray-700 text-center mb-4">{program.description}</p>
                  
                  <div className="space-y-2 mb-6">
                    {program.features.map((feature, index) => (
                      <div key={index} className="flex items-center text-sm text-gray-600">
                        <i className="ri-check-line text-[#b8144a] mr-2"></i>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                  
                  <div className="text-center">
                    <Link 
                      to={program.link}
                      className="bg-[#b8144a] hover:bg-[#a01240] text-white px-6 py-2 rounded-full text-sm font-semibold transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Leadership Structure */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Leadership Structure</h2>
            <p className="text-xl text-gray-600">International Apostolic Council (IAC) Oversight</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-lg text-center">
              <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-user-star-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Apostle Peter Akinnubi</h3>
              <p className="text-lg text-[#b8144a] font-semibold mb-4">Presiding International President</p>
              <p className="text-gray-700">
                Providing apostolic oversight and spiritual direction for all nine strategic programs 
                under the divine mandate from heaven
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-lg text-center">
              <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-user-heart-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Pastor Mrs. Clementina Akinnubi</h3>
              <p className="text-lg text-[#b8144a] font-semibold mb-4">Director of Welfare and Family Affairs</p>
              <p className="text-gray-700">
                Overseeing welfare coordination, family affairs, and the compassionate outreach 
                ministries across the global PAAM network
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-[#b8144a] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Join the Global Movement</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Discover your place in the nine strategic arms of PAAM and become part of the global 
            apostolic engine transforming nations through the doctrine of Christ
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/join"
              className="bg-white text-[#b8144a] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Join PAAM Today
            </Link>
            <Link 
              to="/training"
              className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-[#b8144a] transition-colors whitespace-nowrap cursor-pointer"
            >
              Start Training
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}